import { PaginationButtons } from '@shared/Widgets/PaginationButtons/PaginationButtons';
import { PaginationResponse } from '@shared/Interfaces/Api/Pagination';
import BasicButton from '@shared/Ui/Buttons/BasicButton/BasicButton';
import css from './ItemsSelectionModalFooter.module.css';

interface ItemsSelectionModalFooterProps {
    pagination: PaginationResponse;
    changePage: (page: number) => void;
    handleConfirm: () => void;
    disabledConfirmBtn: boolean;
    isLoadingData: boolean;
}

export const ItemsSelectionModalFooter: React.FC<
    ItemsSelectionModalFooterProps
> = ({
    pagination,
    disabledConfirmBtn,
    handleConfirm,
    isLoadingData,
    changePage,
}) => {
    return (
        <div className={css.footer}>
            {!isLoadingData && (
                <PaginationButtons
                    pagination={pagination}
                    changePage={changePage}
                />
            )}
            <div className={css.btnContainer}>
                <BasicButton
                    onClick={handleConfirm}
                    extraClassName={css.confirm}
                    disabled={disabledConfirmBtn}
                >
                    Confirm selection
                </BasicButton>
            </div>
        </div>
    );
};
